import { Box, styled } from "@mui/material";

export const ProgressBackground = styled(Box)(({ theme }) => ({
  position: "absolute",
  inset: 0,
  background: `linear-gradient(to bottom, 
    ${theme.palette.dsBase.v100}70 0%,
    ${theme.palette.dsBase.v100} 70%,
    ${theme.palette.dsBase.v100} 100%
  ), url('https://challenge-thumbs.b-cdn.net/byb-backgrounds/progress_bg.jpg?width=1440&height=720')`,
  backgroundSize: "100% auto",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center top",
  zIndex: -1,
  width: "100%",
}));
